import {ValueObject} from './ValueObject';
import {Bathroom} from '../hotel/model/accessibility/Bathroom';
import {Bedroom} from '../hotel/model/accessibility/Bedroom';
import {General} from '../hotel/model/accessibility/General';
import {Answer, IAnswer} from './Answer';
import {Question} from './Question';


export class AnswersReference extends ValueObject<{ [key: string]: IAnswer; }> {

  questions: Question[];


  listMissingQuestions() {

    const questionsByKey  = {};
    this.questions.forEach( ( e ) => { questionsByKey[e.value.key]  = e; });

    Object.keys( this.value ).forEach( ( e ) => { delete questionsByKey[e]; } );

    console.log( [this], 'listMissingQuestions', questionsByKey );

  }

  getPhotosAnswers(): Answer[] {

    const answer = [];

    for ( const question of this.questions ) {


      if( question.isPhoto ) {

        const anAnswer: IAnswer = this.value[ question.value.key ];
        if( !anAnswer ) {

          // console.warn( [this], 'getPhotosAnswers', '!anAnswer', 'question.value.key', question.value.key);
        } else {

          const reference = new Answer(  question, anAnswer );
          answer.push( reference );
        }
      }
    }

    return answer;
  }

  onSetValue(value: { [key: string]: IAnswer; }|null) {
  }

  constructor( public section: 'bathroom'|'bedroom'|'general',
               value: { [key: string]: IAnswer; }|null,
               public hotelKey: string|null = null,
               ) {

    super( value );

    if ( 'bathroom' === section ) {

      this.questions = Question.buildArray( Bathroom.getAllQuestionValues() );
    } else if ( 'bedroom' === section ) {

      this.questions = Question.buildArray( Bedroom.getAllQuestionValues() );
    } else if ( 'general' === section ) {

      this.questions = Question.buildArray( General.getAllQuestionValues() );
    }

  }

}
